"use client";
import React, { useRef, useState, useEffect } from "react";
import styles from "./index.module.scss";

const RefferalLogin = () => {
  const otpRefs = useRef<(HTMLInputElement | null)[]>([]);
  const [errors, setErrors] = useState({ verificationEmailOrMobile: "", otp: "" });
  const [step, setStep] = useState(1);
  const [stepForm, setStepForm] = useState(1);
  const [timer, setTimer] = useState(0);
  const [countdown, setCountdown] = useState(3);
  const [isResendVisible, setIsResendVisible] = useState(false);
  const [isValidationDisabled, setIsValidationDisabled] = useState(true);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const [isValidationUsed, setIsValidationUsed] = useState(false);
  const [isSubmitUsed, setIsSubmitUsed] = useState(false);
  const [formData, setFormData] = useState({
    verificationEmailOrMobile: "",
    otp: Array(6).fill(""),
  });

  useEffect(() => {
    let timerId;
    if (timer > 0) {
      timerId = setTimeout(() => setTimer(timer - 1), 1000);
    } else if (timer === 0 && step === 2) {
      setIsResendVisible(true);
    }
    return () => clearTimeout(timerId);
  }, [timer, step]);

  useEffect(() => {
    if (stepForm === 2) {
      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev > 1) {
            return prev - 1;
          } else {
            clearInterval(timer);
            window.location.href = "/referral/dashboard";
            return prev;
          }
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [stepForm]);


  useEffect(() => {
    const isFormValidForValidation =
      formData.verificationEmailOrMobile.trim() && !Object.values(errors).some((error) => error);

    setIsValidationDisabled(!isFormValidForValidation);
  }, [formData, errors]);

  useEffect(() => {
    const isFormValidForSubmit =
      formData.verificationEmailOrMobile.trim() &&
      formData.otp.every((digit) => digit) &&
      !Object.values(errors).some((error) => error);

    setIsSubmitDisabled(isSubmitUsed || !isFormValidForSubmit);
  }, [formData, errors]);

  const handlePaste = (e, index) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData('Text');

    if (/^\d+$/.test(pasteData)) {
      const updatedOtp = [...formData.otp];
      let lastFilledIndex = index;

      for (let i = 0; i < pasteData.length; i++) {
        if (index + i < formData.otp.length) {
          updatedOtp[index + i] = pasteData[i];
          lastFilledIndex = index + i;
        }
      }

      setFormData((prev) => ({ ...prev, otp: updatedOtp }));
      const nextIndex = lastFilledIndex + 1;
      const nextInput = document.getElementById(`otp-input-checkStatus-${nextIndex}`);
      if (nextInput) {
        nextInput.focus();
      } else {
        const lastInput = document.getElementById(`otp-input-checkStatus-${lastFilledIndex}`);
        if (lastInput) lastInput.focus();
      }
    }
  };

  const sendOTP = async () => {
    const isEmail = formData.verificationEmailOrMobile.includes("@") ? true : false;
    setIsValidationDisabled(true);
    setIsValidationUsed(true);

    try {
      const response = await fetch("/api/referral/checkstatus/otp", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(
          isEmail
            ? { Email: formData.verificationEmailOrMobile, OTPFor: "CheckingStatus" }
            : {
              Phone: formData.verificationEmailOrMobile,
              OTPFor: "CheckingStatus",
            }
        ),
      });
      const data = await response.json();
      const res = await data.response


      if (res.Status === "Sent") {

        localStorage.setItem('otpData', JSON.stringify({ otp: data, timestamp: Date.now() }));
        setTimer(180);
        setIsResendVisible(false);
        setStep(2);

      } else if (res.Status === "NotSent") {

        setErrors((prev) => ({
          ...prev,
          verificationEmailOrMobile: "Your email/phone is not registered.",
        }));
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
      setErrors((prev) => ({
        ...prev,
        verificationEmailOrMobile: "Something went wrong. Please try again later.",
      }));
    }
    setIsValidationUsed(false);
  };

  const validate = (name, value) => {

    const updatedErrors = { ...errors };

    switch (name) {
      case "verificationEmailOrMobile":
        updatedErrors.verificationEmailOrMobile = !value.trim()
          ? "Verification email or mobile is required."
          : /^[a-zA-Z]/.test(value)
            ? !/^[\w.%+-]+@[\w.-]+\.[a-zA-Z]{2,}$/.test(value)
              ? "Enter a valid email address."
              : ""
            : /^\d/.test(value)
              ? !/^\d{10}$/.test(value)
                ? "Enter a valid 10-digit mobile number."
                : ""
              : "Invalid input. Please enter a valid email or mobile number.";
        break;
      default:
        break;
    }
    setErrors(updatedErrors);
    // Return true if there's no error for this field, otherwise false
    return !updatedErrors[name];
  };

  const validateOtp = () => {
    const storedOtpData = JSON.parse(localStorage.getItem("otpData") || "{}");

    if (formData.otp.some((digit) => digit === "")) {
      setErrors((prev) => ({ ...prev, otp: "OTP is required" }));
      return false;
    }

    if (storedOtpData?.timestamp) {
      const elapsedTime = Math.floor((Date.now() - storedOtpData.timestamp) / 1000);
      if (elapsedTime >= 180) {
        setErrors((prev) => ({ ...prev, otp: "OTP has expired. Please resend OTP." }));
        return;
      }
    }

    const enteredOtp = formData.otp.join("");
    console.log(enteredOtp, "entered", storedOtpData?.otp.response?.OTP);
    if (storedOtpData?.otp.response?.OTP !== Number(enteredOtp)) {
      setErrors((prev) => ({ ...prev, otp: "Incorrect OTP. Please try again." }));
      return;
    }

    setErrors((prev) => ({ ...prev, otp: "" }));
    return true;
  };

  const handleChange = ({ target: { name, value } }) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
    validate(name, value);
  };

  const handleOtpChange = (index, value) => {
    if (!/\d/.test(value) && value !== "") return;
    setFormData((prev) => {
      const newOtp = [...prev.otp];
      newOtp[index] = value;
      return { ...prev, otp: newOtp };
    });

    setErrors((prev) => ({ ...prev, otp: "" }));

    if (value && index < formData.otp.length - 1) {
      otpRefs.current[index + 1]?.focus();
    }
  };

  const otpRef = (el, index) => {
    otpRefs.current[index] = el;
  };

  const handleOtpKeyDown = (index, e) => {
    const isArrowLeft = e.key === "ArrowLeft";
    const isArrowRight = e.key === "ArrowRight";
    const isBackspace = e.key === "Backspace";

    if (isArrowLeft || isArrowRight) {
      const moveToIndex = isArrowLeft ? index - 1 : index + 1;
      if (moveToIndex >= 0 && moveToIndex < formData.otp.length) {
        const targetInput = document.getElementById(`otp-input-checkStatus-${moveToIndex}`);
        if (targetInput) {
          e.preventDefault();
          targetInput.focus();
        }
      }
    } else if (isBackspace && !formData.otp[index]) {
      const prevIndex = index - 1;
      if (prevIndex >= 0) {
        const prevInput = document.getElementById(`otp-input-checkStatus-${prevIndex}`);
        if (prevInput) {
          e.preventDefault();
          setFormData((prev) => {
            const updatedOtp = [...prev.otp];
            updatedOtp[prevIndex] = "";
            return { ...prev, otp: updatedOtp };
          });
          prevInput.focus();
        }
      }
    }
  }

  const clearDatabase = (dbName) => {
    const request = indexedDB.open(dbName);

    request.onsuccess = (event: any) => {
      const db = event.target.result;

      // Loop through all object stores and clear them
      const objectStoreNames = db.objectStoreNames;

      const clearPromises = [];

      for (let i = 0; i < objectStoreNames.length; i++) {
        const storeName = objectStoreNames[i];

        const transaction = db.transaction(storeName, "readwrite");
        const objectStore = transaction.objectStore(storeName);

        clearPromises.push(
          new Promise((resolve: any, reject) => {
            const clearRequest = objectStore.clear();

            clearRequest.onsuccess = () => {
              console.log(`Cleared all data from object store: ${storeName}`);
              resolve();
            };

            clearRequest.onerror = (event) => {
              console.error(`Error clearing object store: ${storeName}`, event.target.error);
              reject(event.target.error);
            };
          })
        );
      }

      Promise.all(clearPromises)
        .then(() => {
          console.log("All object stores have been cleared.");
        })
        .catch((error) => {
          console.error("Error clearing object stores:", error);
        });
    };

    request.onerror = (event: any) => {
      console.error("Error opening database:", event.target.error);
    };
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitDisabled(true);
    setIsSubmitUsed(true);
    const isEmailValid = validate("verificationEmailOrMobile", formData.verificationEmailOrMobile);
    const isOtpValid = validateOtp();

    const isEmail = formData.verificationEmailOrMobile.includes("@")

    if (isEmailValid && isOtpValid) {

      const response = await fetch("/api/referral/referralData", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ param: isEmail ? `emailAddress=${formData.verificationEmailOrMobile}` : `phone=${formData.verificationEmailOrMobile}` }),
      });

      const data = await response.json();

      if (data.success) {
        // Example usage
        sessionStorage.setItem("RefferalData", JSON.stringify(data.response.lead_info));
        sessionStorage.setItem("RefferalDataNewUser", "true");
        setStepForm(2);
      };

    }
    setIsSubmitDisabled(false);
    setIsSubmitUsed(false);
  }


  return (
    <div className="mt-5 refer-login-wrapper w-88 p-9 min-h-[350px] shadow-lg rounded-lg">
      {/* Form */}
      {stepForm !== 2 && <div className="lg:text-2xl text-xl text-center"><p className={styles.mainheading}>Check Referral Status</p>
      </div>}
      {stepForm == 1 && <div className="refer-login-form-block flex justify-center py-8">
        <div className="refer-login-form w-full max-w-md border border-[#1A325D] p-4 rounded-xl ">
          <form onSubmit={handleSubmit}>
            <div className="space-y-4">
              {step == 1 && (
                <div>
                  <label htmlFor="enter_email_mobile" className="block font-semibold text-sm text-[#666] font-raleway">
                    Enter Email ID / Mobile No <span className="text-red-500">*</span>
                  </label>
                  <div className="flex items-center mt-2 ">
                    <input
                      type="text"
                      name="verificationEmailOrMobile"
                      value={formData.verificationEmailOrMobile}
                      onChange={handleChange}
                      className={`${styles.form_control
                        } flex-1 p-2 border w-32 lg:w-full  rounded-l 
                        ${errors.verificationEmailOrMobile ? "border-red-500" : "border-gray-300"}`}
                      id="enter_email_mobile"
                    />
                    <button
                      type="button"
                      className={`btn bg-[#1A325D] text-white px-4 py-2 rounded-r 
                          ${isValidationDisabled ? "opacity-50 cursor-not-allowed" : ""}`}
                      onClick={() => {
                        sendOTP();
                      }}
                      disabled={isValidationDisabled}
                    >
                      {isValidationUsed ? 'Validating...' : 'Validate'}
                    </button>
                  </div>
                  {errors.verificationEmailOrMobile && (
                    <p className="text-red-500 text-sm mt-1">{errors.verificationEmailOrMobile}</p>
                  )}
                </div>
              )}

              {/* OTP Input */}
              {step == 2 && (
                <div>
                  <label className="block font-raleway font-semibold text-sm">Enter OTP</label>
                  <div className="grid grid-cols-6 gap-2 mt-2">
                    {formData.otp.map((digit, index) => (
                      <input
                        id={`otp-input-checkStatus-${index}`}
                        key={index}
                        type="text"
                        value={digit}
                        ref={(el) => otpRef(el, index)}
                        onChange={(e) => handleOtpChange(index, e.target.value)}
                        onKeyDown={(e) => handleOtpKeyDown(index, e)}
                        onPaste={(e) => handlePaste(e, index)}
                        className="form-control text-center form-control-sm p-2 border rounded"
                        maxLength={1}
                      />
                    ))}
                  </div>
                  {errors.otp && <p className="text-red-500 text-sm mt-1">{errors.otp}</p>}
                  <div className="col-span-6 mt-2 text-left">
                    {isResendVisible ? (
                      <a
                        href="#"
                        onClick={()=>{
                          setFormData((prev)=>({...prev, otp: Array(6).fill("")}));
                          setErrors((prev)=>({...prev,otp:''}));
                          sendOTP()
                        }}
                        className="underline text-[#1a325d] text-xs decoration-1"
                      >
                        Resend OTP
                      </a>
                    ) : (
                      <p className="text-sm font-raleway text-gray-500">
                        Resend OTP in {Math.floor(timer / 60)}:
                        {timer % 60 < 10 ? `0${timer % 60}` : timer % 60}
                      </p>
                    )}
                  </div>
                </div>
              )}

              {/* Submit Button */}
              <div>
                <button
                  type="submit"
                  className={`w-full block bg-yellow-400 text-center py-1 lg:py-2 rounded-full text-[#1A325D] font-semibold border border-black
                        ${isSubmitDisabled
                      ? "bg-[#EBEBE4] text-gray-700 border border-[#dcdcdc] cursor-not-allowed"
                      : "bg-[#ffc907] text-[#1A325D] border border-[#1a325d] cursor-pointer"
                    }`}
                  disabled={isSubmitDisabled}
                >
                  {isSubmitUsed ? "Submitting" : 'SUBMIT'}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>}
      {stepForm == 2 && (
        <dialog open className={` ${styles.dialogcontent}`}>
          <div className={styles.contentContainer}>
              <h2 className={styles.heading}>Thank You!</h2>
              <p className={styles.parasubtitle}>We are redirecting you to the status dashboard</p>
              <div className="w-6 h-6 border-4 m-auto border-[#1a325d] border-t-transparent rounded-full animate-spin"></div>
              <p className={styles.countdown}>...redirecting in {countdown} sec</p>
          </div>
        </dialog>
      )}
    </div>
  );
};

export default RefferalLogin;
